import React, { useEffect, useState } from 'react';
import '../styles/madmovie.css';
import jirachiImage from '../img/jirachi-Photoroom.png';
import axios from 'axios';
import confetti from 'canvas-confetti';
import '../styles/LunchRecommend/LunchRecommend.css';


const LunchRecommend = () => {
  const [countdown, setCountdown] = useState(null);
  const [menus, setMenus] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState('버튼을 눌러주세요!');
  const [loading, setLoading] = useState(true);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedCategoryName, setSelectedCategoryName] = useState('');

  useEffect(() => {
    fetchMenus();
  }, []);

  const fetchMenus = async () => {
    try {
      const res = await axios.get('menu/menus');
      setMenus(res.data);
    } catch (e) {
      console.error('메뉴 불러오기 실패:', e);
    } finally {
      setLoading(false);
    }
  };

  const pickRandomMenu = () => {
    if (!selectedCategoryId) {
      setSelectedMenu('먼저 카테고리를 선택해주세요!');
      return;
    }

    const category = menus.find(cat => cat.categoryId === selectedCategoryId);
    const menuList = category?.menus || [];

    if (menuList.length === 0) {
      setSelectedMenu('선택한 카테고리에 메뉴가 없습니다 😢');
      return;
    }

    // 카운트다운
    let countdownValue = 3;
    setCountdown(countdownValue);
    const countdownInterval = setInterval(() => {
      countdownValue -= 1;
      setCountdown(countdownValue);
      if (countdownValue === 0) {
        clearInterval(countdownInterval);
      }
    }, 1000);

    // 뽑기 애니메이션
    let delay = 50;
    let maxDelay = 300;
    let totalDuration = 3000;
    let elapsed = 0;

    const shuffle = () => {
      const randomIndex = Math.floor(Math.random() * menuList.length);
      const picked = menuList[randomIndex];
      setSelectedMenu(`👉 ${picked.menuName}`);

      if (elapsed < totalDuration) {
        setTimeout(shuffle, delay);
        elapsed += delay;
        delay = Math.min(delay * 1.15, maxDelay);
      } else {
        const final = menuList[Math.floor(Math.random() * menuList.length)];
        setSelectedMenu(
          <span>
            🎉 오늘의 추천 메뉴는 <b>{final.menuName}</b>입니다!<br />
            <span className="menu-by">[{selectedCategoryName}] by 추천인 : {final.createdBy}</span>
          </span>
        );

        confetti({
          particleCount: 120,
          spread: 100,
          origin: { y: 0.6 },
        });
      }
    };

    shuffle();
  };

  return (
    <div>
      {/* 카테고리 선택 */}
      <div className="category-buttons">
        {menus.map(category => (
          <button
            key={category.categoryId}
            className={selectedCategoryId === category.categoryId ? 'selected' : ''}
            onClick={() => {
              setSelectedCategoryId(category.categoryId);
              setSelectedCategoryName(category.categoryName);
              setSelectedMenu(`${category.categoryName}를 선택하셨습니다. 이제 아래 뽑기 버튼을 눌러보세요!`);
            }}
          >
            {category.categoryName}
          </button>
        ))}
      </div>

      {/* 카운트다운 */}
      {countdown !== null && (
        <p className="countdown-display">
          {countdown > 0 ? `${countdown}초...!` : ''}
        </p>
      )}

      {/* 결과 출력 */}
      <p className="menu-display">{selectedMenu}</p>

      {/* 뽑기 버튼 */}
      <button onClick={pickRandomMenu} className="pick-menu-button">
        오늘 뭐 먹지?
      </button>
    </div>
  );
};

export default LunchRecommend;
